<button [attr.id]="'btnDialogClose'" mat-button mat-dialog-close>
  <mat-icon>close</mat-icon>
</button>

<h1 mat-dialog-title>{{'intervention-instance-reminder.reminder_information' | translate}}</h1>
<div mat-dialog-content class="mat-typography">
  <div [ngSwitch]="displaySubject | async">
    <div *ngSwitchCase="'DEFAULT'">
      <div class="row">
        <div class="col-12 col-md-6">
          <div class="row mb-2">
            <div class="col-sm-3">
              <strong>{{'intervention-instance-reminder.form_create_intervention_instance_reminder_starts_at' | translate}}:</strong>
            </div>
            <div class="col-sm-9">{{helper.localizeDateTimestamp(reminder.attributes.start)}}</div>
          </div>

          <div class="row mb-2">
            <div class="col-sm-3"><strong>{{'intervention-instance-reminder.rhythm' | translate}}:</strong></div>
            <div class="col-sm-9">
              {{'intervention-instance-reminder.reminder_rhythm_1' | translate}} {{reminder.attributes.configuration.pause}}
              {{('intervention-instance-reminder.' + reminder.attributes.configuration.unit) |
              translate}}{{'intervention-instance-reminder.reminder_rhythm_2' | translate}}
            </div>
          </div>

          <div class="row mb-2">
            <div class="col-sm-3"><strong>{{'intervention-instance-reminder.performed' | translate}}:</strong></div>
            <div class="col-sm-9">
              {{reminder.attributes.performed ? reminder.attributes.performed : 0}} / {{reminder.attributes.maximum_reminders}}
            </div>
          </div>

          <p><strong>{{'intervention-instance-reminder.message_preview'| translate}}:</strong></p>
          <p>
            <ng-template *ngIf="reminder.attributes.content?.greeting; then showCustomGreeting else showDefaultGreeting"></ng-template>
            <ng-template #showCustomGreeting>
              <h6>{{ reminder.attributes.content.greeting }}</h6>
            </ng-template>
            <ng-template #showDefaultGreeting>
              <h6>{{ getReminderGreeting() }}</h6>
            </ng-template>
          </p>
          <p>
            <ng-template *ngIf="reminder.attributes.content?.text; then showCustomMessage else showDefaultMessage"></ng-template>
            <ng-template #showCustomMessage>
              {{ reminder.attributes.content.text }}
            </ng-template>
            <ng-template #showDefaultMessage>
              {{ getReminderMessage() }}
            </ng-template>
          </p>
          <p>
            <ng-template *ngIf="reminder.attributes.content?.closing; then showCustomClosing else showDefaultClosing"></ng-template>
            <ng-template #showCustomClosing>
              {{ reminder.attributes.content.closing }}
            </ng-template>
            <ng-template #showDefaultClosing>
              {{ getReminderClosing() }}
            </ng-template>
          </p>
          <p>
            <ng-template *ngIf="reminder.attributes.content?.signature; then showCustomSignature else showDefaultSignature"></ng-template>
            <ng-template #showCustomSignature>
              <strong>{{ reminder.attributes.content.signature }}</strong>
            </ng-template>
            <ng-template #showDefaultSignature>
              <strong>{{ getReminderSignature() }}</strong>
            </ng-template>
          </p>
        </div>

        <div class="col-12 col-md-6">
          <div class="mb-4 text-start">
            <div class="card fixHeight">
              <div *ngIf="(pagedReminderLog$ | async)?.length === 0" class="card-body">
                <p class="centering">{{'intervention-instance-reminder.no_reminder_logs_found' | translate}}</p>
              </div>
              <div *ngIf="(pagedReminderLog$ | async).length !== 0" class="list-group overflowList">
                <div
                  [attr.id]="'reminder_log_' + reminderLog.id"
                  *ngFor="let reminderLog of pagedReminderLog$ | async"
                  class="list-group-item list-group-item-action flex-column align-items-start"
                >
                  <div class="row justify-content-around mb-3">
                    <div class="col-12 col-lg-8 mb-1">
                      <p>
                        <ng-template
                          *ngIf="reminderLog.attributes.content?.greeting; then showCustomGreetingLog else showDefaultGreetingLog"
                        ></ng-template>
                        <ng-template #showCustomGreetingLog>
                          <h6>{{ reminderLog.attributes.content.greeting }}</h6>
                        </ng-template>
                        <ng-template #showDefaultGreetingLog>
                          <h6>{{ getReminderGreeting() }}</h6>
                        </ng-template>
                      </p>
                      <p>
                        <ng-template
                          *ngIf="reminderLog.attributes.content?.text; then showCustomMessageLog else showDefaultMessageLog"
                        ></ng-template>
                        <ng-template #showCustomMessageLog>
                          {{ reminderLog.attributes.content.text }}
                        </ng-template>
                        <ng-template #showDefaultMessageLog>
                          {{ getReminderMessage() }}
                        </ng-template>
                      </p>
                      <p>
                        <ng-template
                          *ngIf="reminderLog.attributes.content?.closing; then showCustomClosingLog else showDefaultClosingLog"
                        ></ng-template>
                        <ng-template #showCustomClosingLog>
                          {{ reminderLog.attributes.content.closing }}
                        </ng-template>
                        <ng-template #showDefaultClosingLog>
                          {{ getReminderClosing() }}
                        </ng-template>
                      </p>
                      <p>
                        <ng-template
                          *ngIf="reminderLog.attributes.content?.signature; then showCustomSignatureLog else showDefaultSignatureLog"
                        ></ng-template>
                        <ng-template #showCustomSignatureLog>
                          <strong>{{ reminderLog.attributes.content.signature }}</strong>
                        </ng-template>
                        <ng-template #showDefaultSignatureLog>
                          <strong>{{ getReminderSignature() }}</strong>
                        </ng-template>
                      </p>
                    </div>
                    <div class="col-12 col-lg-4 mb-1">
                      <p><small>{{helper.localizeDateTimestamp(reminderLog.attributes.created_at)}}</small></p>

                      <p>{{ 'intervention-instance-reminder.incomplete_questionnaires' | translate }}:</p>
                      <p *ngFor="let questionnaire of reminderLog.attributes.questionnaires">
                        <span class="text-info">
                          <small>{{ questionnaire.title }} (ID {{ questionnaire.id }})</small>
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="card-footer">
              <app-pagination-list
                #paginator
                (emitPageChange)="updatePagedReminderLogs($event)"
                [_isLoading]="isLoading$ | async"
                [_items]="reminderLogs$ | async"
              ></app-pagination-list>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngSwitchCase="'UPDATE'">
      <div [formGroup]="reminderForm">
        <!-- Starts at -->
        <div class="col-12">
          <div class="col-form-label col-12 pt-0">
            <strong>{{'intervention-instance-reminder.form_create_intervention_instance_reminder_starts_at' | translate}}:</strong>
          </div>
          <div class="row" [ngClass]="{ errorMargin: maxTimesErrorMessage || controlHasErrors(f.get('max_times')) }">
            <div class="col-md-6 col-12">
              <mat-form-field class="full-width" appearance="outline">
                <input
                  [attr.id]="'starts_at'"
                  matInput
                  [ngxMatDatetimePicker]="picker"
                  placeholder="Choose a date"
                  formControlName="starts_at"
                  [disabled]="false"
                  readonly
                />
                <mat-datepicker-toggle matSuffix [for]="$any(picker)"></mat-datepicker-toggle>
                <ngx-mat-datetime-picker
                  #picker
                  [attr.id]="'picker'"
                  [showSpinners]="showSpinners"
                  [showSeconds]="showSeconds"
                  [stepHour]="stepHour"
                  [stepMinute]="stepMinute"
                  [stepSecond]="stepSecond"
                  [touchUi]="touchUi"
                  [color]="color"
                  [enableMeridian]="enableMeridian"
                >
                </ngx-mat-datetime-picker>
              </mat-form-field>
            </div>
            <div class="col-md-6 col-12">
              <!-- Max_Times -->
              <mat-form-field
                [style.width.%]="100"
                appearance="outline"
                *appVariable="getLimitOfMaxTimesOf(f.get('time_interval_unit').value) as max"
              >
                <mat-label>{{ 'intervention-instance-reminder.max_number_of_repetitions' | translate }}</mat-label>
                <input
                  [attr.id]="'max_times'"
                  type="number"
                  autocomplete="off"
                  formControlName="max_times"
                  matInput
                  (input)="resetMaxTimesErrorMessage()"
                  required
                  min="1"
                  [max]="max"
                />
                <mat-error *ngIf="controlHasErrors(f.get('max_times'))">
                  <span *ngIf="f.get('time_interval_unit').value === 'minute'">
                    {{ 'intervention-instance-reminder.valid_max_number_of_repetitions_required_minute' | translate : { max: max } }}
                  </span>
                  <span *ngIf="f.get('time_interval_unit').value === 'hour'">
                    {{ 'intervention-instance-reminder.valid_max_number_of_repetitions_required_hour' | translate : { max: max } }}
                  </span>
                  <span *ngIf="f.get('time_interval_unit').value === 'day'">
                    {{ 'intervention-instance-reminder.valid_max_number_of_repetitions_required_day' | translate : { max: max } }}
                  </span>
                </mat-error>
              </mat-form-field>
              <mat-error *ngIf="maxTimesErrorMessage">
                {{ maxTimesErrorMessage }}
              </mat-error>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 col-12">
            <!-- Time interval -->
            <mat-form-field [style.width.%]="100" appearance="outline">
              <mat-label>{{ 'intervention-instance-reminder.time_interval' | translate }}</mat-label>
              <input
                [attr.id]="'time_interval'"
                type="number"
                [attr.min]="reminder.attributes.performed"
                autocomplete="off"
                formControlName="time_interval"
                matInput
              />
              <mat-error *ngIf="controlHasErrors(f.get('time_interval'))">
                {{ 'intervention-instance-reminder.time_interval_required' | translate }}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-md-6 col-12">
            <!-- Time interval unit -->
            <mat-form-field appearance="outline">
              <mat-label>{{ 'intervention-instance-reminder.time_interval_unit' | translate }}</mat-label>
              <mat-select
                [attr.id]="'time_interval_unit'"
                formControlName="time_interval_unit"
                name="time_interval_unit"
                (selectionChange)="resetMaxTimesErrorMessage()"
              >
                <mat-option [attr.id]="'option_' + unit" *ngFor="let unit of unitList" [value]="unit">
                  {{ ('intervention-instance-reminder.' + unit) | translate }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <mat-divider class="mb-3"></mat-divider>

        <mat-form-field [style.width.%]="100" appearance="outline" floatLabel="always">
          <mat-label>{{'intervention-instance-reminder.content_greetings' | translate}}</mat-label>
          <textarea
            [attr.id]="'content_greeting'"
            [placeholder]="getReminderGreeting()"
            autocomplete="off"
            formControlName="content_greeting"
            matInput
          ></textarea>
        </mat-form-field>

        <!-- Content text -->
        <mat-form-field [style.width.%]="100" appearance="outline" floatLabel="always">
          <mat-label>{{'intervention-instance-reminder.content_text' | translate}}</mat-label>
          <textarea
            [attr.id]="'content_text'"
            [placeholder]="getReminderMessage()"
            autocomplete="off"
            formControlName="content_text"
            cdkTextareaAutosize
            cdkAutosizeMinRows="5"
            matInput
          ></textarea>
        </mat-form-field>

        <mat-form-field [style.width.%]="100" appearance="outline" floatLabel="always">
          <mat-label>{{'intervention-instance-reminder.content_closing' | translate}}</mat-label>
          <textarea
            [attr.id]="'content_closing'"
            [placeholder]="getReminderClosing()"
            autocomplete="off"
            formControlName="content_closing"
            matInput
          ></textarea>
        </mat-form-field>

        <mat-form-field [style.width.%]="100" appearance="outline" floatLabel="always">
          <mat-label>{{'intervention-instance-reminder.content_signature' | translate}}</mat-label>
          <textarea
            [attr.id]="'content_ending'"
            [placeholder]="getReminderSignature()"
            autocomplete="off"
            formControlName="content_signature"
            matInput
          ></textarea>
        </mat-form-field>
      </div>
    </div>
    <div *ngSwitchCase="'DELETE'">{{'intervention-instance-reminder.delete_reminder_info' | translate }}</div>
  </div>
</div>
<div mat-dialog-actions align="end">
  <button [attr.id]="'btnCancel'" mat-button mat-dialog-close>{{'intervention-instance-reminder.cancel' | translate}}</button>
  <div [ngSwitch]="displaySubject | async">
    <div *ngSwitchCase="'DEFAULT'">
      <button [attr.id]="'btnToggleUpdate'" mat-button [disabled]="isDisabled()" (click)="setDisplay('UPDATE')">
        {{'intervention-instance-reminder.toggle_update' | translate}}
      </button>
      <button [attr.id]="'btnToggleDelete'" mat-button [disabled]="isDisabled()" (click)="setDisplay('DELETE')">
        {{'intervention-instance-reminder.toggle_delete' | translate}}
      </button>
    </div>
    <div *ngSwitchCase="'UPDATE'">
      <button [attr.id]="'btnToggleDetail'" mat-button [disabled]="isDisabled()" (click)="setDisplay('DEFAULT')">
        {{'intervention-instance-reminder.toggle_detail' | translate}}
      </button>
      <app-button-feedback
        [_isDisabled]="reminderForm.invalid || !!maxTimesErrorMessage"
        [_setId]="'btnUpdateInterventionInstanceReminder'"
        (click)="updateInterventionInstanceReminder()"
        [_defaultButtonText]="'intervention-instance-reminder.reminder_confirm'"
        [_responseText]="updateInterventionInstanceReminder$ | async"
      ></app-button-feedback>
    </div>
    <div *ngSwitchCase="'DELETE'">
      <button [attr.id]="'btnSetDisplay'" mat-button [disabled]="isDisabled()" (click)="setDisplay('DEFAULT')">
        {{'intervention-instance-reminder.toggle_detail' | translate}}
      </button>
      <app-button-feedback
        [_setId]="'btnDeleteInterventionInstanceReminder'"
        (click)="deleteInterventionInstanceReminder()"
        [_defaultButtonText]="'intervention-instance-reminder.reminder_delete'"
        [_responseText]="deleteInterventionInstanceReminder$ | async"
      ></app-button-feedback>
    </div>
  </div>
</div>
